import { useCallback, useMemo } from 'react';

import { CustomStorage } from '@/entities/Storage';
import {
  KEY_LOCAL_STORAGE,
  KEY_SESSION_STORAGE,
  KEY_STORAGE_TYPE,
} from '@/features/login/constants/keys';
import { parseJwt } from '@/utils/parseJwt';

const mapStorage = new Map<string, Storage>([
  [KEY_LOCAL_STORAGE, localStorage],
  [KEY_SESSION_STORAGE, sessionStorage],
]);

const getCurrentStorage = (): Storage => {
  const currentType = localStorage.getItem(KEY_STORAGE_TYPE);
  if (currentType) {
    const storage = mapStorage.get(currentType);
    if (storage) return storage;
  }
  return sessionStorage;
};

export const useStorage = (): CustomStorage => {
  const getItem = useCallback((key: string) => {
    const storage = getCurrentStorage();
    return storage?.getItem(key);
  }, []);

  const parsedToken = useMemo(() => {
    const token = getItem(`token`);
    if (!token) return undefined;

    return parseJwt(token) as { userId: string };
  }, [getItem]);

  return {
    getItem,
    setItem: (key: string, value: string) => {
      const storage = getCurrentStorage();
      return storage?.setItem(key, value);
    },
    setStorageType: (name: string) => {
      localStorage.setItem(KEY_STORAGE_TYPE, name);
    },
    parsedToken,
  };
};
